import { ProductAsset } from '../../types/graphql/product'

/**
 * @deprecated Use ResponsiveImage component. Do not use JS to alter sources. That is not server side render viable where viewports are unknown still.
 */
export function resizeShopifyImageSource({
  height,
  source,
  width,
}: {
  height: number
  source: string
  width: number
}): string {
  // TODO: Fix this auto-generated suppression.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const matches = source?.match(/^(.*shopify.*)(\.(?:jpg|png|gif).*)$/)
  return matches ? `${matches[1]}_${width}x${height}${matches[2]}` : source
}

/**
 * @deprecated Use ResponsiveImage component. Do not use JS to alter sources. That is not server side render viable where viewports are unknown still.
 */
export function resizeShopifyImage({
  height,
  image,
  width,
}: {
  image: ProductAsset
  height: number
  width: number
}): ProductAsset {
  return {
    ...image,
    source: resizeShopifyImageSource({ height, source: image.source, width }),
  }
}

/**
 * @deprecated Use ResponsiveImage component. Do not use JS to alter sources. That is not server side render viable where viewports are unknown still.
 */
export function makeShopifyImageSrcSet(imageSource: string, sizes: number[]): string {
  return sizes
    .map(size => {
      const resizedSource = resizeShopifyImageSource({
        height: size,
        source: imageSource,
        width: size,
      })
      return `${resizedSource} ${size}w`
    })
    .join(', ')
}
